module.exports = __webpack_public_path__ + "static/media/back_reverse.c6e8eaa6.svg";